import React, { useState } from "react";
import Modal from "./Modal";
import { BtnGeneral } from "../../styles/Buttons";


const descriptionStyle = {
  fontSize: "0.95rem",
  fontWeight: "600",
  color: "#666",
  marginBottom: "20px",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "0.95rem",
  marginBottom: "20px",
  outline: "none",
  transition: "border-color 0.2s ease-in-out",
};

const buttonsContainerStyle = {
  display: "inline-flex",
  gap: "14px",
};

const FechaGestacionModal = ({
  isOpen,
  fechaEmbarazo,
  setFechaEmbarazo,
  onClose,
  onSave,
  patientUnicId,
}) => {

  const handleGuardar = () => {
    console.log("handleGuardar disparado");
    onSave({
      fecha: fechaEmbarazo,
      paciente: patientUnicId,
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={'Paciente Embarazada'} width={'351px'} minH={'30vh'} >
      <div>
        <p style={descriptionStyle}>
          Por favor digite la fecha de embarazo o fecha de gestación
        </p>

        <input type="date" value={fechaEmbarazo} onChange={(e) => setFechaEmbarazo(e.target.value)}
          style={inputStyle} onFocus={(e) => (e.target.style.borderColor = "#4CAF50")} 
          onBlur={(e) => (e.target.style.borderColor = "#ccc")}
        />

        <div style={buttonsContainerStyle}>
          <BtnGeneral bg="green" padding="7px" radius="8px" flex="2" onClick={handleGuardar} > Guardar </BtnGeneral>
          <BtnGeneral bg="gray" padding="7px" radius="8px" flex="2" onClick={onClose} > Cancelar </BtnGeneral>
        </div>
      </div>
    </Modal>
  );
};

export default FechaGestacionModal;
